import { useRawAppTitle } from './AppTitle'
import PageTitle from './PageTitle'

export default function CurrentPageTitle(): JSX.Element {
  const currentPage = useRawAppTitle().slice(-1)[0]

  return <PageTitle>{currentPage}</PageTitle>
}
